import React, { useState } from 'react';
import { Drawer, Select } from 'antd';
import { FaBars } from "react-icons/fa";
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'


const PhoneMenu = () => {
  const [visible, setVisible] = useState(false);

  const { Option } = Select;

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
// eslint-disable-next-line
  const [actualLanguage, setActualLanguage] = useState('Português')
    const { t, i18n } = useTranslation()

    const changeLanguage = (value) => {
        if (value === 'pt') {
            i18n.changeLanguage('pt')
            // setActualLanguage('en-US')
        } 
        else if(value === 'en'){
            i18n.changeLanguage('en')
            // setActualLanguage('pt-BR')
        }
        else {
            i18n.changeLanguage('es')
            // setActualLanguage('es-E')
        }
    }

  return (
    <>
      <FaBars size={'1.5rem'} color={'white'} onClick={showDrawer}></FaBars>
      <Drawer
        title=""
        placement="left"
        closable={true}
        onClose={onClose}
        visible={visible}
        bodyStyle={{padding: '0'}}
      >
            <Navigation>
                <Ul>
                    <Li style={{marginTop: '60px'}}><Link onClick={onClose} to='/'>{t('Home')}</Link></Li>
                    <Li><Link onClick={onClose} to='/projetos'>{t('Projetos')}</Link></Li>
                    <Li><Link onClick={onClose} to='/techs'>{t('Techs')}</Link></Li>
                    <Li><Link onClick={onClose} to='/certificados'>{t('Certificados')}</Link></Li>
                </Ul>
            </Navigation>
            <div style={{width: 'auto', textAlign: 'center', padding: '20px 0'}}>
                <Select style={{width: '80%'}} defaultValue={actualLanguage} onChange={changeLanguage}>
                    <Option value="pt">Português</Option>
                    <Option value="en">Inglês</Option>
                    {/* <Option value="es">Espanhol</Option> */}
                </Select>
            </div>
      </Drawer>
    </>
  );
};

export default PhoneMenu;

const Navigation = styled.div`
    width: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    & * {
        color: #100800!important;
    }
`

const Ul = styled.ul`
    list-style-type: none;
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
`

const Li = styled.li`
    border-bottom: 1px solid rgba(16,8,0, .1);
    width: 100%;
    margin: 0;
    padding: 10px 15px;
    cursor: pointer;
    transition: all .3s;
`